import { queryGetOffsegMasterInfoWithOrganizationId } from '../api/queryGetOffsegMasterInfoWithOrganizationId';
import {
	offsegGetType,
	sessionStorageKeyAuthorizationToken,
	dialog,
	masterInfoLabel,
	applicableData,
	allCarInfo,
	allDriverInfo,
} from '../const/commonConst';
import { HandlerOutputType } from '../type/HandlerType';
import { OffsegMasterInfoLinkedToOrganization } from '../type/MasterInfoType';
import { responseType } from '../type/ResponseType';
import { isResponseTypeError, isResponseTypeSessionNotExist } from '../utils/responseTypeChecker';
import { convertCarInfoList, convertDriverInfoList } from '../utils/masterInfoConverter';
import { nonNullable } from '../utils/nonNullable';
import { getSessionStorage } from '../utils/sessionStorageHandler';
import { redirectToLogin } from '../utils/redirectToLogin';

/**
 * Offsegの組織IDに紐づくマスタ情報を取得する関数
 */
export const getOffsegMasterInfoWithOrganizationIdHandler = async (
	getType: (typeof offsegGetType)[keyof typeof offsegGetType],
	organizationId?: string,
): Promise<HandlerOutputType<OffsegMasterInfoLinkedToOrganization>> => {
	// 認証トークンを取得する
	const authorizationToken = getSessionStorage(sessionStorageKeyAuthorizationToken);

	if (!authorizationToken) {
		return [dialog.systemError, undefined];
	}

	const getMasterInfoInput = {
		authorizationToken: authorizationToken,
		organizationId: organizationId,
	};

	try {
		// Offsegのマスタ情報を取得する
		const [isApiError, getMasterInfoResult] = await queryGetOffsegMasterInfoWithOrganizationId(getType, getMasterInfoInput, authorizationToken);
		console.log(getMasterInfoResult);

		if (isApiError || !getMasterInfoResult || isResponseTypeError(getMasterInfoResult)) {
			return [dialog.apiError, undefined];
		}

		if (isResponseTypeSessionNotExist(getMasterInfoResult)) {
			redirectToLogin();
		}

		const notExistedList: string[] = [];
		if (getMasterInfoResult.getOffsegCarInfo && getMasterInfoResult.getOffsegCarInfo.responseType === responseType.notExistApiResponseData) {
			notExistedList.push(masterInfoLabel.offsegCar);
		}

		if (getMasterInfoResult.getOffsegDriverInfo.responseType === responseType.notExistApiResponseData) {
			notExistedList.push(masterInfoLabel.offsegDriver);
		}

		if (notExistedList.length) {
			const customDialog = {
				isOpened: dialog.notExistMasterInfo.isOpened,
				title: dialog.notExistMasterInfo.title,
				text: dialog.notExistMasterInfo.text.replace(applicableData, notExistedList.join()), // カンマ区切で連結
			};
			return [customDialog, undefined];
		}

		const masterInfo: OffsegMasterInfoLinkedToOrganization = {
			offsegCarInfoList: getMasterInfoResult.getOffsegCarInfo
				? [allCarInfo, ...convertCarInfoList(getMasterInfoResult.getOffsegCarInfo.carInfoList.filter(nonNullable))]
				: [],
			offsegDriverInfoList: [allDriverInfo, ...convertDriverInfoList(getMasterInfoResult.getOffsegDriverInfo.driverInfoList.filter(nonNullable))],
		};

		return [dialog.success, masterInfo];
	} catch (err: unknown) {
		console.error(err);
		return [dialog.systemError, undefined];
	}
};
